/**
 * Opening our own support channel — the in-app feedback drawer.
 *
 * This replaces `loopedin.utils.ts`, which sent people to `app.loopedin.io`, a third-party
 * site under someone else's branding. Toni put it plainly: "das sollte so nicht sein, oder?"
 * (Ticket 176ce751.) Worse than the branding: a report filed over there never reaches the
 * ticket list we actually work from, so anyone who followed that link was writing into a
 * channel nobody reads.
 *
 * The feedback drawer lives in `app-layout`, i.e. above every screen that could raise one of
 * these errors, so an event is enough — no context provider, no prop drilling through the
 * sync dialog.
 */

export const OPEN_FEEDBACK_EVENT = 'pai:open-feedback';

export interface SupportPrefill {
  /** Pre-filled ticket subject — give the error a name so the report is not "geht nicht". */
  title?: string;
  /** Pre-filled body, e.g. what the user was doing when it happened. */
  description?: string;
}

export const openSupport = (prefill: SupportPrefill = {}) => {
  window.dispatchEvent(new CustomEvent<SupportPrefill>(OPEN_FEEDBACK_EVENT, { detail: prefill }));
};
